import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { CALL_API } from 'redux-api-middleware';
import { preserveSequence } from '../../middleware/sequence';
import { GP_PROFILE_API } from '../../../../config/endpoints';
import { validate } from '../../middleware/validator';

// ACTIONS
export const FETCH_GPS_REQUEST = 'SEARCH_GP/FETCH_GPS_REQUEST';
export const FETCH_GPS_RECEIVE = 'SEARCH_GP/FETCH_GPS_RECEIVE';
export const FETCH_GPS_FAILURE = 'SEARCH_GP/FETCH_GPS_FAILURE';
export const SELECT_GP = 'SEARCH_GP/SELECT';
export const SELECT_GP_ERROR = 'SEARCH_GP/SELECT_ERROR';
export const SET_EMPTY_LIST = 'SEARCH_GP/SET_EMPTY_LIST';

// ACTION CREATORS
const loadGPs = (text, apiEndpoint) => ({
  [CALL_API]: {
    endpoint: `${apiEndpoint}/practices?q=${encodeURIComponent(text.trim())}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: preserveSequence([
      FETCH_GPS_REQUEST,
      FETCH_GPS_RECEIVE,
      FETCH_GPS_FAILURE,
    ]).map(action => ({ ...action, meta: { ...action.meta, text } })),
    options: { addAuth: true },
  },
});

export const searchGPs = (text = '', apiEndpoint = GP_PROFILE_API) => ({
  type: 'SEARCH_GP_VALIDATION',
  [validate]: {
    validator: () => (text && text.length),
    success: loadGPs(text, apiEndpoint),
    fail: { type: SET_EMPTY_LIST },
  },
});

export const selectGP = index => ({
  type: SELECT_GP,
  index,
});

// SELECTORS
export const getGPs = state => state.gps;
export const getSearchText = state => state.search;
export const getSelectedIndex = state => state.selectedIndex;
export const getSelectionError = state => state.selectionError;
export const getResultsLoaded = state => state.resultsLoaded;
export const getHasNoResults = state => getResultsLoaded(state) && getGPs(state).length === 0;
export const getHasError = state => state.error != null;

// REDUCERS
export const gps = handleActions({
  [SET_EMPTY_LIST]: () => [],
  [FETCH_GPS_RECEIVE]: (state, action) => {

    const filteredData =  action.payload.data.filter((gp) => {
      return (gp.country === "England" || gp.country === "england" || gp.country === "ENGLAND")
    }) || [];
    return filteredData;
  },
}, []);

export const search = handleActions({
  [SET_EMPTY_LIST]: () => '',
  [FETCH_GPS_REQUEST]: (state, action) => action.meta.text,
}, '');

export const selectedIndex = handleActions({
  [SET_EMPTY_LIST]: () => null,
  [FETCH_GPS_REQUEST]: () => null,
  [SELECT_GP]: (state, action) => (action.index >= 0 ? action.index : null),
}, null);

export const selectionError = handleActions({
  [SET_EMPTY_LIST]: () => null,
  [FETCH_GPS_REQUEST]: () => null,
  [SELECT_GP]: () => null,
  [SELECT_GP_ERROR]: () => 'Select a valid GP.',
}, null);

export const resultsLoaded = handleActions({
  [SET_EMPTY_LIST]: () => true,
  [FETCH_GPS_REQUEST]: () => false,
  [FETCH_GPS_RECEIVE]: () => true,
}, false);

export const error = handleActions({
  [SET_EMPTY_LIST]: () => null,
  [FETCH_GPS_REQUEST]: () => null,
  [FETCH_GPS_FAILURE]: (state, action) => action.payload,
}, null);

export default combineReducers({
  gps,
  search,
  selectedIndex,
  selectionError,
  resultsLoaded,
  error,
});
